<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" width="760" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <div v-if="loading">
      <v-row no-gutters class="mt-2 mb-n4">
        <v-col cols="6" class="pr-3">
          <v-text-field
              v-model="order.through_number"
              label="Номер заявки"
              disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-text-field
              v-model="order.order_type"
              label="Тип пропуска"
              disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="grey my-2"></v-divider>
      <v-row no-gutters class="text-center subtitle-1">
        <v-col cols="12" class="font-weight-bold">Список посетителей</v-col>
      </v-row>
      <v-divider class="grey my-2"></v-divider>
      <template
          v-for="(item,i) in order_visitors"
      >
        <OrderVisitors
            :key="i+'visitor'"
            :item="item"
            :index="i"
            :organizations="organizations_selector"
            :visitors="selectors.visitors"
            :user_selector="user_selector"
            :add-visitor.sync="add_visitors"
            :order-visitors.sync="order_visitors"
            :special-error.sync="special_error"
            :order-type="3"
            :visitor_error="visitor_error"
        >
        </OrderVisitors>
      </template>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-btn
            text
            @click="addNewVisitor"
            class="pr-0 mt-1"
        >
          Добавить еще одного посетителя
          <v-icon>add</v-icon>
        </v-btn>
      </v-row>
    </div>
    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import selectors from "@/urls/selectors";
import OrderVisitors from "@/modules/templates/OrderVisitors";
import {SemipolarSpinner} from "epic-spinners";

export default {
  name: "OrdersVisitorsDialog",
  props: {
    opened: Boolean,
    orderData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    OrderVisitors,
    SemipolarSpinner
  },
  data() {
    return {
      loading:false,
      save_loading: false,
      agreed: false,
      order: undefined,
      order_visitors: [],
      add_visitors: [],
      selectors: {
        visitors: []
      },
      special_error: [],
      visitor_error: []
    }
  },
  watch: {
    order_visitors: {
      handler: function() {
        this.special_error = []
      },
      deep: true
    }
  },
  computed: {
    form_title () {
      return "Изменить посетителей заявки"
    },
    user_selector(){
      return selectors.SELECTORS.USERS.ALL()
    },
    organizations_selector(){
      return selectors.SELECTORS.VISITORS.ORGANIZATIONS()
    }
  },
  methods: {
    ...mapActions({
      changeOrders: "entitled/changeOrders",
      orderDisagreed: "entitled/orderDisagreed",
      loadOrderDetail: "entitled/loadOrdersDetail",
      loadUsersVisitorsSelector: "selectors/loadUsersVisitorsSelector"
    }),
    close(){
      this.$emit("close", false)
    },
    loadSelectors() {
      this.loadUsersVisitorsSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.visitors = val
        }
      })
    },
    loadOrderData(){
      this.order = JSON.parse(JSON.stringify(this.orderData))

      this.loadOrderDetail({
        url: undefined,
        id: this.orderData.id,
        finalizer: (data) => {
          // Преобразование посетителей перед выводом в форме
          this.order_visitors = []
          this.add_visitors = []
          for (let item in data.visitors) {
            this.order_visitors.push(data.visitors[item])
            this.add_visitors.push({visitor: true, portal_user: false})
          }

          this.loading = true
        }
      })
    },
    // Добавление еще одного поля создания нового посетителя
    addNewVisitor() {
      this.order_visitors.push({})
      this.add_visitors.push({
        visitor: false,
        portal_user: false
      })
    },
    save() {
      this.save_loading = true

      // Преобразования списка посетителей перед отправкой данных
      // Проверка на пустоту, проверка на пустое значение
      if (this.order_visitors.length > 0) {
        // Присваиваем значения исходных массивов временным
        let tempArrayAddVisitor = []
        let tempArrayVisitor = this.order_visitors
        // Фильтруем массив посетителей от пустых полей
        this.order_visitors = this.order_visitors.filter(item => Object.keys(item).length)
        this.order_visitors = this.order_visitors.filter(item => item.user || item.visitor_id || item.last_name)
        // Сравниваем исходных с отфильтрованным массивом и фильтруем массив булей
        for (let i in tempArrayVisitor) {
          for (let j in this.order_visitors) {
            if (tempArrayVisitor[i] === this.order_visitors[j]) {
              tempArrayAddVisitor.push(this.add_visitors[i])
            }
          }
        }
        this.add_visitors = tempArrayAddVisitor
        // Кладем данные, который идут на отправку
        this.order.visitors = this.order_visitors
        // Если после фильтрации наш массив остался пустой, то возвращаем его в исходное состояние
        if (this.order_visitors.length === 0) {
          this.order_visitors = [{visitor_id: undefined}]
          this.add_visitors = [{
            visitor: false,
            portal_user: false
          }]
        }
      }

      this.changeOrders({
        data: this.order,
        finalizer: () => {
          this.$emit("close", this.order)
          this.save_loading = false
        },
        catcher:(val) => {
          if(!val.visitors){
            this.mapErrors(val)
          } else {
            this.special_error = val.visitors
          }
          this.save_loading = false
        }
      })
    }
  },
  created() {
    this.loadOrderData()
    this.loadSelectors()
  }
}
</script>

<style scoped>

</style>
